import RestApiService from './rest.api.service';
;
class CardAPIService extends RestApiService {
    constructor() {
        super();
        super.authorized = true;
        super.updateContextPath('cards');
    }
    create(payload) {
        return this.post('', payload);
    }
    update(payload) {
        return this.patch(payload.cardId + '?columnId=' + payload.columnId, {
            title: payload.title,
            checked: payload.checked,
        });
    }
    move(payload) {
        return this.patch(`${payload.cardId}/move?`, payload);
    }
}
export const cardAPISrvice = new CardAPIService();
